import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Sparkles, Zap, Target, Rocket } from 'lucide-react';

const SolutionSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const solutions = [
    {
      icon: Sparkles,
      title: 'Eu Crio Tudo Para Você',
      description: 'Design moderno, textos persuasivos e estrutura otimizada. Você não precisa se preocupar com nada técnico.',
    },
    {
      icon: Zap,
      title: 'Site Rápido e Profissional',
      description: 'Landing page otimizada para conversão, que carrega em segundos e funciona perfeitamente em qualquer dispositivo.',
    },
    {
      icon: Target,
      title: 'Focado em Gerar Contatos',
      description: 'Cada elemento é pensado para transformar visitantes em clientes. Botões estratégicos, formulários inteligentes.',
    },
    {
      icon: Rocket,
      title: 'Entrega Rápida',
      description: 'Seu site no ar em dias, não meses. Comece a gerar resultados o quanto antes.',
    },
  ];

  return (
    <section ref={ref} className="py-24 bg-black text-white relative overflow-hidden" id="servicos">
      {/* Background Effect */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}></div>
      </div>

      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="inline-block mb-4">
            <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              A SOLUÇÃO
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Eu cuido de tudo por você
          </h2>
          <p className="text-xl text-gray-400">
            Você foca no seu negócio. Eu cuido da sua presença digital.
          </p>
        </motion.div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.03, y: -5 }}
              className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-blue-500 transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <solution.icon className="text-white" size={28} />
              </div>
              <h3 className="text-2xl font-bold mb-3">{solution.title}</h3>
              <p className="text-gray-400 leading-relaxed">{solution.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 text-center"
        >
          <div className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl px-8 py-6">
            <p className="text-2xl font-bold">
              Simples, eficiente e sem complicação
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionSection;
